module.exports = __webpack_public_path__ + "img/旅遊.c40ea447.png";